import { FC, ReactNode, createContext } from "react";

import { IDeliveryContext } from "../types/delivery";
import usePersistentState from "../hooks/usePersistentState";

export const DeliveryContext = createContext<IDeliveryContext | null>(null);

interface Props {
  children: ReactNode;
}

const DeliveryProvider: FC<Props> = ({ children }) => {
  const [address, setAddress] = usePersistentState<string | null>(
    "address",
    null,
  );
  const [deliveryMethodId, setDeliveryMethodId] = usePersistentState<
    number | null
  >("deliveryMethodId", null);

  return (
    <DeliveryContext.Provider
      value={{
        address,
        deliveryMethodId,
        setAddress,
        setDeliveryMethodId,
      }}
    >
      {children}
    </DeliveryContext.Provider>
  );
};

export default DeliveryProvider;
